import { render, staticRenderFns } from "./backListModal.vue?vue&type=template&id=4f2090cc&scoped=true&"
import script from "./backListModal.vue?vue&type=script&lang=js&"
export * from "./backListModal.vue?vue&type=script&lang=js&"
import style0 from "./backListModal.vue?vue&type=style&index=0&id=4f2090cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2090cc",
  null
  
)

export default component.exports